import PropTypes from 'prop-types';
import React, { cloneElement } from 'react';

import ModalBody from './ModalBody';
import ModalFooter from './ModalFooter';
import ModalHeader from './ModalHeader';

function Modal(props) {
  const {
    type,
    show,
    onClose,
    children
  } = props;

  if (!show) { return null; }

  // Clone children and pass size and type as props
  const childrenWithProps = React.Children.map(children, (child) => {
    if (child.type === ModalHeader) {
      return cloneElement(child, { type, onClose });
    }
    if (child.type === ModalBody) {
      return cloneElement(child);
    }
    if (child.type === ModalFooter) {
      return cloneElement(child, { onClose });
    }
    return child;
  });

  return (
    <div
      className="blendx__modal-backdrop"
      onClick={onClose}
      role="button"
      tabIndex={0}
      onKeyPress={(e) => {
        if (e.key === 'Enter') { onClose(); }
      }}
    >
      <div
        className="modal-content"
        onClick={(e) => e.stopPropagation()}
        role="button"
        tabIndex={0}
        onKeyPress={(e) => {
          if (e.key === 'Enter') { e.stopPropagation(); }
        }}
      >
        {childrenWithProps}
      </div>
    </div>
  );
}

Modal.propTypes = {
  type: PropTypes.oneOf(['default', 'success', 'error', 'warning', 'info']),
  show: PropTypes.bool,
  onClose: PropTypes.func,
  children: PropTypes.node
};

Modal.defaultProps = {
  type: 'default',
  show: false,
  onClose: () => { },
  children: null
};

Modal.Header = ModalHeader;
Modal.Body = ModalBody;
Modal.Footer = ModalFooter;

export default Modal;
